import { ApolloProvider } from '@apollo/react-hooks'
import { ChakraProvider } from '@chakra-ui/react'
import { createHistory, LocationProvider } from '@reach/router'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import client from './client'
import theme from './theme'

const history = createHistory(window)

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <LocationProvider history={history}>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </LocationProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
